module.exports = __webpack_public_path__ + "img/EMAIL.242e8189.svg";